// import React from 'react';
// import ALink from "./ALink";
// import { constants } from './Constant';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../assets/css/fontawesome.css';
// import '../assets/css/root.css';
// import '../assets/css/lightbox.css';

// const Header = () => {
//   const pathname = window.location.pathname;
//   return (
//     <header className="header-area header-sticky">
//       <div className="container">
//         <div className="row">
//           <div className="col-12">
//             <nav className="main-nav">
//               <a href="/" className="logo">
//                 Logo
//               </a>
//               <ul className="nav">
//                 <li><ALink label={`${constants?.headerPage.menu1}`} to={'/'} styles={`${ pathname === '/' ||  pathname === '/Home' ? 'active' : '' }`} /></li>
//                 <li className="has-sub">
//                   <ALink label={`${constants?.headerPage.menu2}`} to={'/Sports'} styles={`${ pathname === '/Sports' || pathname === '/Agri' ||  pathname === '/Ocr' ? 'active' : '' }`} />
//                   <ul className="sub-menu">
//                     <li><ALink label={`${constants?.headerPage.submenu1}`} to={'/Sports'} styles={''} /></li>
//                     <li><ALink label={`${constants?.headerPage.submenu2}`} to={'/Agri'} styles={''} /></li>
//                     <li><ALink label={`${constants?.headerPage.submenu3}`} to={'/Ocr'} styles={''} /></li>
//                   </ul>
//                 </li>
//                 <li className="has-sub">
//                   <ALink label={`${constants?.headerPage.menu3}`} to={'/Consulting'} styles={`${ pathname === '/Consulting' || pathname === '/Bootcamp' ||  pathname === '/Hireandmanage' ||  pathname === '/Training' ? 'active' : '' }`} />
//                   <ul className="sub-menu">
//                     <li><ALink label={`${constants?.headerPage.submenu4}`} to={'/Consulting'} styles={''} /></li>
//                     <li><ALink label={`${constants?.headerPage.submenu5}`} to={'/Bootcamp'} styles={''} /></li>
//                     <li><ALink label={`${constants?.headerPage.submenu6}`} to={'/Hireandmanage'} styles={''} /></li>
//                     <li><ALink label={`${constants?.headerPage.submenu7}`} to={'/Training'} styles={''} /></li>
//                   </ul>
//                 </li>
//                 <li className="has-sub">
//                   <ALink label={`${constants?.headerPage.menu4}`} to={'/Aboutcompany'} styles={`${ pathname === '/Aboutcompany' || pathname === '/Insights' ? 'active' : '' }`} />
//                   <ul className="sub-menu">
//                   <li><ALink label={`${constants?.headerPage.submenu8}`} to={'/Aboutcompany'} styles={''} /></li>    
//                   <li><ALink label={`${constants?.headerPage.submenu9}`} to={'/Insights'} styles={''} /></li>
//                   </ul>
//                 </li>
//                 <li className="has-sub">
//                   <ALink label={`${constants?.headerPage.menu5}`} to={'/Pagetosupport'} styles={`${ pathname === '/Pagetosupport' || pathname === '/Jobposting' ? 'active' : '' }`} />
//                   <ul className="sub-menu">
//                     <li><ALink label={`${constants?.headerPage.submenu10}`} to={'/Pagetosupport'} styles={''} /></li>
//                     <li><ALink label={`${constants?.headerPage.submenu11}`} to={'/Jobposting'} styles={''} /></li>
//                   </ul>
//                 </li>
//                 <li className="has-sub">
//                   <ALink label={`${constants?.headerPage.menu6}`} to={'/Contactpage'} styles={`${ pathname === '/Contactpage' ? 'active' : '' }`} />
//                   <ul className="sub-menu">
//                     <li><ALink label={`${constants?.headerPage.submenu12}`} to={'/Contactpage'} styles={''} /></li>
//                   </ul>
//                 </li>
//               </ul>
//               <a className='menu-trigger'>
//                 <span>Menu</span>
//               </a>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useEffect } from 'react';
import ALink from "./ALink";
import { constants } from './Constant';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/fontawesome.css';
import '../assets/css/root.css';
import '../assets/css/lightbox.css';
import $ from 'jquery';

const Header = () => {
  const pathname = window.location.pathname;

  useEffect(() => {
    // Header background on scroll
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      var box = $('.header-text').height();
      var header = $('header').height();

      if (scroll >= box - header) {
        $("header").addClass("background-header");
      } else {
        $("header").removeClass("background-header");
      }
    });

    // Menu trigger toggle
    if ($('.menu-trigger').length) {
      $(".menu-trigger").on('click', function () {
        $(this).toggleClass('active');
        $('.header-area .nav').slideToggle(200);
      });
    }

    // Dropdown logic for links
    $('.has-sub > a').on('click', function (e) {
      e.preventDefault(); // Prevent navigation for clickable dropdowns

      const submenu = $(this).siblings('.sub-menu');

      if (submenu.is(':visible')) {
        submenu.slideUp(300);
        $(this).parent().removeClass('is-open-sub');
      } else {
        $('.sub-menu').slideUp(300); // Close other submenus
        $('.has-sub').removeClass('is-open-sub'); // Remove active class from other dropdowns
        submenu.slideDown(300);
        $(this).parent().addClass('is-open-sub');
      }
    });

    // Smooth scroll for section links
    $('.scroll-to-section a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - 79
      }, 500);
    });

    return () => {
      // Cleanup to avoid memory leaks
      $(window).off('scroll');
      $(".menu-trigger").off('click');
      $('.has-sub > a').off('click');
      $('.scroll-to-section a').off('click');
    };
  }, []);

  return (
    <header className="header-area header-sticky">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <nav className="main-nav">
              <a href="/" className="logo">Logo</a>
              <ul className="nav">
                <li>
                  <ALink
                    label={`${constants?.headerPage.menu1}`}
                    to={'/'}
                    styles={`${pathname === '/' || pathname === '/Home' ? 'active' : ''}`}
                  />
                </li>


                <li className="has-sub">
                  <ALink
                    label={`${constants?.headerPage.menu2}`}
                    to={'/Product'}
                    styles={`${pathname === '/Product' ? 'active' : ''}`}
                  />
                  <ul className="sub-menu">
                    <li><ALink label={`${constants?.headerPage.submenu1}`} to={'/Sports'} styles={''} /></li>
                    <li><ALink label={`${constants?.headerPage.submenu2}`} to={'/Agri'} styles={''} /></li>
                    <li><ALink label={`${constants?.headerPage.submenu3}`} to={'/Ocr'} styles={''} /></li>
                  </ul>
                </li>

                <li className="has-sub">
                  <ALink
                    label={`${constants?.headerPage.menu3}`}
                    to={'/Services'}
                    styles={`${pathname === '/Services' ? 'active' : ''}`}
                  />
                  <ul className="sub-menu">
                    <li><ALink label={`${constants?.headerPage.submenu4}`} to={'/Consulting'} styles={''} /></li>
                    <li><ALink label={`${constants?.headerPage.submenu5}`} to={'/Bootcamp'} styles={''} /></li>
                    <li><ALink label={`${constants?.headerPage.submenu6}`} to={'/Hireandmanage'} styles={''} /></li>
                    <li><ALink label={`${constants?.headerPage.submenu7}`} to={'/Training'} styles={''} /></li>
                  </ul>
                </li>


                <li className="has-sub">
                  <ALink
                    label={`${constants?.headerPage.menu4}`}
                    to={'/Aboutus'}
                    styles={`${pathname === '/Aboutus' ? 'active' : ''}`}
                  />
                  <ul className="sub-menu">
                    <li><ALink label={`${constants?.headerPage.submenu8}`} to={'/Aboutcompany'} styles={''} /></li>
                    <li><ALink label={`${constants?.headerPage.submenu9}`} to={'/Insights'} styles={''} /></li>
                  </ul>
                </li>


                <li className="has-sub">
                  <ALink
                    label={`${constants?.headerPage.menu5}`}
                    to={'/Careers'}
                    styles={`${pathname === '/Careers' ? 'active' : ''}`}
                  />
                  <ul className="sub-menu">
                    <li><ALink label={`${constants?.headerPage.submenu10}`} to={'/Pagetosupport'} styles={''} /></li>
                    <li><ALink label={`${constants?.headerPage.submenu11}`} to={'/Jobposting'} styles={''} /></li>
                  </ul>
                </li>


                <li className="has-sub">
                  <ALink
                    label={`${constants?.headerPage.menu6}`}
                    to={'/Contactus'}
                    styles={`${pathname === '/Contactus' ? 'active' : ''}`}
                  />
                  <ul className="sub-menu">
                    <li><ALink label={`${constants?.headerPage.submenu12}`} to={'/ContactPage'} styles={''} /></li>
                  </ul>
                </li>
              </ul>
              <a className='menu-trigger'>
                <span>Menu</span>
              </a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

